module.exports = __webpack_public_path__ + "static/media/header.465e3de2.jpg";